document.addEventListener('DOMContentLoaded', function () {

  const drawer     = document.getElementById('mmdDrawer');
  const overlay    = document.getElementById('mmdOverlay');
  const panel2     = document.getElementById('mmdPanel2');
  const backBtn    = document.getElementById('mmdBack');
  const backLabel  = document.getElementById('mmdBackLabel');
  const subContent = document.getElementById('mmdSubpanelContent');

  if (!drawer) return;

  // ── Open drawer ──
  function openDrawer() {
    drawer.classList.add('mmd-drawer--open');
    overlay.classList.add('mmd-overlay--visible');
    document.body.classList.add('mmd-lock');
  }

  // ── Close drawer ──
  function closeDrawer() {
    drawer.classList.remove('mmd-drawer--open');
    overlay.classList.remove('mmd-overlay--visible');
    document.body.classList.remove('mmd-lock');
    const detailsEl = document.getElementById('Details-menu-drawer-container');
    if (detailsEl) detailsEl.removeAttribute('open');
    setTimeout(closeSubPanel, 350);
  }

  // ── Close subpanel ──
  function closeSubPanel() {
    if (panel2) {
      panel2.classList.remove('mmd-panel--open');
      panel2.setAttribute('aria-hidden', 'true');
    }
  }

  // ── Overlay click closes drawer ──
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // ── Close buttons ──
  document.addEventListener('click', function (e) {
    if (e.target.closest('.mmd-close')) {
      closeDrawer();
    }
  });

  // ── Back button ──
  if (backBtn) backBtn.addEventListener('click', closeSubPanel);

  // ── Escape key ──
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // ── Tab switching ──
  document.addEventListener('click', function (e) {
    const tab = e.target.closest('.mmd-tab');
    if (!tab) return;

    const idx = tab.dataset.tabIndex;

    document.querySelectorAll('.mmd-tab').forEach(function (t) {
      t.classList.remove('mmd-tab--active');
      t.setAttribute('aria-selected', 'false');
    });
    tab.classList.add('mmd-tab--active');
    tab.setAttribute('aria-selected', 'true');

    document.querySelectorAll('.mmd-category-list').forEach(function (l) {
      l.classList.remove('mmd-category-list--active');
    });

    const target = document.getElementById('mmdCategoryList' + idx);
    if (target) target.classList.add('mmd-category-list--active');

    closeSubPanel();
  });

  // ── Open subpanel ──
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-open-panel="2"]');
    if (!btn) return;

    const pi = btn.dataset.parentIndex;
    const si = btn.dataset.subcategoryIndex;

    const dataBlock = document.querySelector(
      '.mmd-subpanel-data[data-parent-index="' + pi + '"][data-subcategory-index="' + si + '"]'
    );
    if (!dataBlock) return;

    subContent.innerHTML = '';

    const titleEl = document.createElement('span');
    titleEl.className = 'mmd-subpanel-title';
    titleEl.textContent = dataBlock.querySelector('.mmd-subpanel-title').textContent;
    subContent.appendChild(titleEl);

    const va = dataBlock.querySelector('.mmd-subpanel-viewall');
    if (va) {
      const a = document.createElement('a');
      a.href = va.href;
      a.className = 'mmd-subpanel-viewall';
      a.textContent = va.textContent;
      subContent.appendChild(a);
    }

    dataBlock.querySelectorAll('.mmd-subpanel-link').forEach(function (link) {
      const a = document.createElement('a');
      a.href = link.href;
      a.className = 'mmd-subpanel-link';
      a.textContent = link.textContent;
      subContent.appendChild(a);
    });

    const activeTab = document.querySelector('.mmd-tab--active');
    if (backLabel && activeTab) backLabel.textContent = activeTab.textContent;

    panel2.classList.add('mmd-panel--open');
    panel2.setAttribute('aria-hidden', 'false');
  });

  // ── Make openDrawer globally available for summary onclick ──
  window.mmdOpen = openDrawer;

});
